export default "__VITE_ASSET__ByAfXpUw__"